export const GENERATION_COMPLETE_EVENT = "generation:complete";

export const emitGenerationComplete = ({
  source = "generation",
  title = "Generation complete",
  body = "Your request finished.",
  success = true,
} = {}) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(GENERATION_COMPLETE_EVENT, {
      detail: {
        source,
        title,
        body,
        success: Boolean(success),
        timestamp: Date.now(),
      },
    }),
  );
};
